// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file api/v1/common.proto (package api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/v1/common.proto.
 */
export const file_api_v1_common: GenFile =
  /*@__PURE__*/
  fileDesc(
    "ChNhcGkvdjEvY29tbW9uLnByb3RvEgZhcGkudjEiZwoSUGFnaW5hdGlvbk1ldGFkYXRhEhQKDGN1cnJlbnRfcGFnZRgBIAEoBRIRCglwYWdlX3NpemUYAiABKAUSEwoLdG90YWxfaXRlbXMYAyABKAUSEwoLdG90YWxfcGFnZXMYBCABKAUiFwoJSURSZXF1ZXN0EgoKAmlkGAEgASgFQhtaGWNhc2hicm9rZXIvZ2VuL2FwaS92MTthcGliBnByb3RvMw",
  );

/**
 * @generated from message api.v1.PaginationMetadata
 */
export type PaginationMetadata = Message<"api.v1.PaginationMetadata"> & {
  /**
   * @generated from field: int32 current_page = 1;
   */
  currentPage: number;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: int32 total_items = 3;
   */
  totalItems: number;

  /**
   * @generated from field: int32 total_pages = 4;
   */
  totalPages: number;
};

/**
 * Describes the message api.v1.PaginationMetadata.
 * Use `create(PaginationMetadataSchema)` to create a new message.
 */
export const PaginationMetadataSchema: GenMessage<PaginationMetadata> =
  /*@__PURE__*/
  messageDesc(file_api_v1_common, 0);

/**
 * @generated from message api.v1.IDRequest
 */
export type IDRequest = Message<"api.v1.IDRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message api.v1.IDRequest.
 * Use `create(IDRequestSchema)` to create a new message.
 */
export const IDRequestSchema: GenMessage<IDRequest> =
  /*@__PURE__*/
  messageDesc(file_api_v1_common, 1);
